import { Expose, Type } from 'class-transformer';
import { IsOptional } from 'class-validator';
import { ChallengeDto } from './challenge.dto';

export class ChallengeBaseResponseDto {
    @Expose()
    @IsOptional()
    authChallengeToken: string;

    @Expose()
    @IsOptional()
    @Type(() => ChallengeDto)
    challenge?: ChallengeDto;
}
